import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import TemuComplianceInfoPage from '@/temu-platform/modules/compliance/ComplianceInfoPage';
import TemuCompliancePhotosPage from '@/temu-platform/modules/compliance/CompliancePhotosPage';
import CertificateBindPage from '@/temu-platform/modules/compliance/CertificateBindPage';

/** 合规资质 · 合规信息 */
export function TemuComplianceInfoRoute() {
  return <TemuComplianceInfoPage />;
}

/** 合规资质 · 实拍图 */
export function TemuCompliancePhotosRoute() {
  return <TemuCompliancePhotosPage />;
}

/** 合规资质 · 产品证书资质（cert.query + queryNeedUploadItems + uploadProductCert） */
export function TemuComplianceCertsRoute() {
  return <CertificateBindPage />;
}

/** 合规根路径进入合规信息 */
export function TemuComplianceIndexRoute() {
  return <TemuComplianceInfoRoute />;
}

/** 旧「产品合规」入口：按 dim 兼容跳转 */
export function TemuProductQualRoute() {
  const [searchParams] = useSearchParams();
  const dim = String(searchParams.get('dim') || '').toLowerCase();
  if (dim === 'photo' || dim === 'photos') {
    return <Navigate to="../photos" replace />;
  }
  if (dim === 'certificate' || dim === 'cert' || dim === 'certs') {
    return <Navigate to="../certs" replace />;
  }
  return <Navigate to="../info" replace />;
}

/** 旧「合规资料」入口 */
export function TemuComplianceMaterialsRoute() {
  return <Navigate to="../info" replace />;
}
